import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    tone?: 'default' | 'inverted'
    className?: string
}

const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    align = 'left',
    tone = 'default',
    className
}): ReactNode => {
    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            <p
                className={cn(
                    'inline-flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.22em]',
                    tone === 'inverted' ? 'text-festive-saffron' : 'text-primary'
                )}
            >
                <span aria-hidden='true' className='h-px w-6 bg-current' />
                {eyebrow}
            </p>

            <h2 id={id} className='mt-4 font-heading text-4xl leading-[1.05] tracking-tight text-balance sm:text-5xl'>
                {title}
            </h2>

            {description && (
                <p
                    className={cn(
                        'mt-5 text-lg leading-relaxed text-pretty',
                        tone === 'inverted' ? 'text-background/75' : 'text-muted-foreground'
                    )}
                >
                    {description}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
